import { UserBiqData } from "@app/schemas/biq";
import { createReducer, on } from "@ngrx/store";
import { updateUserBiq } from "../actions/biq.action";

const initialUserBiq: UserBiqData = {
  firstName: '',
  lastName: '',
  location: '',
  birthYear: null,
  gender: '',
  ethnicity: [],
  grade: '',
  graduationYear: '',
  schoolName: '',
  major: '',
  isWorking: false,
  futureLocation: '',
}
export const userBiqReducer = createReducer(
  initialUserBiq,
  on(updateUserBiq, (_, action) => action.user),
);